import {
  Component,
  EventEmitter,
  input,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { PolicyService } from '../../../../policy/services/policy.service';
import { AuthService } from '../../../../auth/services/auth.service';
import Policy from '../../../../../core/data/models/policy.mode';
import { DatePipe, DecimalPipe, NgClass } from '@angular/common';
import { SwalService } from '../../../../../common/services/swal.service';
import { SharedModule } from '../../../../../common/shared.module';
import { policyMask } from '../../../../../common/constants/masks';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import PolicyTypes from '../../../../../common/enums/policyTypes';
import { SettingService } from '../../../../policy/services/setting.service';
import { dateFormats } from '../../../../../common/constants/dateFormats';
import filterBy from '../../../../../common/functions/filterBy';
import { Subscription } from 'rxjs/internal/Subscription';
import { PaymentService } from '../../../../policy/services/payment.service';
import PoliciesBalance from '../../../../../core/data/models/policies.balance.model';

@Component({
  selector: 'app-policy-step',
  imports: [NgClass, DatePipe, DecimalPipe, SharedModule],
  providers: [PolicyService, SettingService],
  templateUrl: './policy-step.component.html',
  styleUrl: './policy-step.component.css',
})
export class PolicyStepComponent implements OnInit, OnDestroy {
  @Output() onPolicySelected = new EventEmitter<Policy>();

  @Output() onGoBack = new EventEmitter<void>();
  @Input() showBackButton = true;
  @Input() idNumber?: string;
  @Input() policyFilter?: PolicyTypes;
  @Input() redirectToPaymentOnPending = false;

  policies: Policy[] = [];
  filteredPolicies: Policy[] = [];
  settingsSubscription?: Subscription;
  balanceSubscription?: Subscription;
  balances: PoliciesBalance[] = [];

  searchFilter = '';

  policySelected: Policy | null = null;

  indexSelected: number = -1;
  policyMask = policyMask;
  protected readonly dateFormats = dateFormats;

  constructor(
    private policyService: PolicyService,
    private authService: AuthService,
    private swalService: SwalService,
    private settingService: SettingService,
    private paymentService: PaymentService,
  ) {}

  @Input() set value(policy: Policy | null) {
    this.policySelected = policy;
  }

  ngOnInit(): void {
    this.getPolicies();
    this.balances = this.paymentService.balance;
    this.balanceSubscription = this.paymentService.balance$.subscribe(
      (value) => {
        this.balances = value;
      },
    );
  }

  ngOnDestroy() {
    this.settingsSubscription?.unsubscribe();
    this.balanceSubscription?.unsubscribe();
  }

  findPendingBalance(policy: Policy): PoliciesBalance | undefined {
    const match = this.balances.find(
      (b) => b.policyNumber === policy.policyNumber,
    );
    if (!match || match.amount <= 0 || policy.slob.code === 520) return undefined;
    return match;
  }

  async getPolicies() {
    this.swalService.showLoading();
    const user = this.authService.user;

    const idNumber = this.idNumber || user.idTokenClaims?.extension_IdNumber!;

    if (this.settingsSubscription) this.settingsSubscription.unsubscribe();

    this.settingsSubscription = this.settingService.$types.subscribe(
      async (settingResult) => {
        if (!this.settingService.fetched) return;

        try {
          const result = await lastValueFrom(
            this.policyService.getMyPolicies(idNumber),
          );
          if (this.policyFilter) {
            result.data = result.data.filter((policy) => {
              const slobs = settingResult[this.policyFilter!];
              return slobs?.includes(policy.slob.code) ?? false;
            });
          }
          this.policies = result.data;
          this.filteredPolicies = result.data;
        } catch (e) {}
        this.swalService.dismiss();
      },
    );
  }

  selectPolicy(policy: Policy, index: number) {
    // if (this.redirectToPaymentOnPending) {
    //   const pending = this.findPendingBalance(policy);
    //   if (pending) {
    //     this.paymentService.openWithPolicy(pending);
    //     return;
    //   }
    // }
    this.indexSelected = index;
    this.onPolicySelected.emit(policy);
  }

  goBack() {
    this.onGoBack.emit();
  }

  handleSearch() {
    this.filteredPolicies = filterBy(this.policies, this.searchFilter, [
      'policyNumber',
    ]);
  }
}
